var document = require('./_global').document;
module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// ./~/element-ui/~/core-js/library/modules/_html.js
// module id = 1151
// module chunks = 2